import React from 'react';
import { Box, Typography, Divider, List, ListItem, ListItemText } from '@mui/material';

const BlitzChatRulesSection = () => {
  // Define your chat rules here:
  const rules = [
    "No taking deals off platform; doing so may result in account suspension",
    "All payments need to be made inside Blitz, via offers or payouts",
    "View guarantees are not allowed without an agreed upon base rate",
    "Maintain respectful and professional interactions"
  ];

  return (
    <Box
      sx={{
        border: '1px solid #ccc',
        borderRadius: 1,
        p: 2,
        mb: 2,
        backgroundColor: '#fafafa',
      }}
    >
      <Typography variant="h6" gutterBottom>
        Blitz Chat Rules
      </Typography>
      <Divider sx={{ mb: 1 }} />
      <List dense disablePadding>
        {rules.map((rule, index) => (
          <ListItem key={index} disableGutters>
            <ListItemText primary={`${index + 1}. ${rule}`} />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default BlitzChatRulesSection;
